"use strict";

exports.__esModule = true;
exports.TimelineValueWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _timelineDefinitions = require("../../Timeline/timelineDefinitions");
var _TimelineValueElement = require("./TimelineValueElement");
var _TimelineValueFields = require("./TimelineValueFields");
var _TimelineValueHeader = require("./TimelineValueHeader");
var _TimelineValueThumbnail = require("./TimelineValueThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TimelineValueWidget = exports.TimelineValueWidget = {
  name: "TimelineValue",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "TimelineValueWidget.label",
    defaultMessage: "Timeline Value"
  }),
  icon: "trending-up",
  group: _widgetGroups.TIMELINE_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "TimelineValue",
      props: Object.assign({
        width: 256,
        height: 64,
        timelineName: _timelineDefinitions.TIME_SERIES_CLASSIFICATION
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: false,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "backgroundColor", "backgroundColorSource"],
  requiresProps: ["x", "y", "width", "height", "timelineName"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 64,
      min: 32,
      max: 768
    }
  },
  components: {
    Element: _TimelineValueElement.TimelineValueElement,
    Fields: _TimelineValueFields.TimelineValueFields,
    Thumbnail: _TimelineValueThumbnail.TimelineValueThumbnail,
    Header: _TimelineValueHeader.TimelineValueHeader
  }
};